<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" @close="handleClose"
        :close-on-click-modal="false" top="5vh">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="150px">
            <el-form-item label="企业名称" prop="companyName">
                <el-select v-model="form.companyName" filterable remote placeholder="请输入企业名(可搜索)"
                    :remote-method="handleSearchCompanyList" clearable allow-create default-first-option
                    @change="handleCompanyChange" style="width: 100%;">
                    <el-option v-for="company in companyOptions" :key="company.companyId" :label="company.companyName"
                        :value="company.companyName">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- 社会信用代码 -->
            <el-form-item label="社会信用代码" prop="socialCreditId">
                <el-input :disabled="inputDisabled" v-model="form.socialCreditId" placeholder="请输入统一社会信用代码" clearable />
            </el-form-item>

            <!-- 联系方式 -->
            <el-form-item label="法人姓名" prop="bossName">
                <el-input :disabled="inputDisabled" v-model="form.bossName" placeholder="请输入法人姓名" clearable />
            </el-form-item>

            <!-- 联系方式 -->
            <el-form-item label="联系方式" prop="bossPhone">
                <el-input :disabled="inputDisabled" v-model="form.bossPhone" placeholder="请输入联系电话作为主账号" clearable />
            </el-form-item>

            <!-- 联系人姓名 -->
            <el-form-item label="联系人姓名" prop="contactName">
                <el-input :disabled="inputDisabled" v-model="form.contactName" placeholder="请输入联系人姓名" clearable />
            </el-form-item>

            <!-- 联系人电话 -->
            <el-form-item label="联系人电话" prop="contactPhone">
                <el-input :disabled="inputDisabled" v-model="form.contactPhone" placeholder="请输入联系人电话" clearable />
            </el-form-item>

            <!-- 对公账户 -->
            <el-form-item label="对公账户" prop="companyBankId">
                <el-input :disabled="inputDisabled" v-model="form.companyBankId" placeholder="请输入对公账户" clearable />
            </el-form-item>

            <!-- 所在街道 -->
            <el-form-item label="所在街道" prop="areaCode">
                <div v-if="inputDisabled">
                    <el-input :disabled="inputDisabled" v-model="form.address" />
                </div>
                <div v-else>
                    <el-cascader ref="address" v-model="value1" :options="options" :props="props"
                        style="width: 49%; margin-right: 2%" @change="cityChange"></el-cascader>
                    <el-cascader ref="address2" v-model="value2" :options="options2" :props="props" @change="roadChange"
                        style="width: 49%"></el-cascader>
                </div>

            </el-form-item>

            <el-form-item label="法人身份证人像面" prop="bossCardFront">
                <div class="upload-box">
                    <el-upload :disabled="inputDisabled" v-loading="loading" ref="front" action="" :auto-upload="false"
                        :show-file-list="false" name="files" :on-change="(file) => {
                            handleChange(file, '0');
                        }">
                        <img slot="default" :src="imgUrl[0]
                            ? this.baseUrl + 'admin/file/get?ossFilePath=' + imgUrl[0]
                            : 'imgs/card-1.png'
                            " alt="" />
                    </el-upload>
                </div>
            </el-form-item>

            <el-form-item label="法人身份证国徽面" prop="bossCardBack">
                <div class="upload-box">
                    <el-upload :disabled="inputDisabled" ref="back" action="" :auto-upload="false"
                        :show-file-list="false" list-type="picture-card" :limit="1" name="files" :on-change="(file) => {
                            handleChange(file, '1');
                        }
                            ">
                        <img :src="imgUrl[1]
                            ? this.baseUrl + 'admin/file/get?ossFilePath=' + imgUrl[1]
                            : 'imgs/card-2.png'
                            " alt="" />
                    </el-upload>
                </div>
            </el-form-item>

            <el-form-item label="营业执照" prop="businessLicense">
                <div class="upload-box">
                    <el-upload :disabled="inputDisabled" ref="businessLicenseRef" class="upload-demo" action=""
                        :on-change="uploadYyzz" :on-remove="removeYyzz" :accept="'.jpg,.jpeg,.gif,.png,.pdf'" :limit="1"
                        :auto-upload="false" name="营业执照" list-type="picture-card">
                        <div v-if="inputDisabled">
                            <el-image fit="contain"
                                :src="baseUrl + 'admin/file/get?ossFilePath=' + form.businessLicense">
                                <div slot="error"
                                    style="width: 100%;height: 100%;  display: flex;  align-items: center; justify-content: center;  background-color: #f5f7fa">
                                    <i style=" font-size: 32px;  color: #c0c4cc;" class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                        <div v-else>
                            <el-button v-if="uploading == 0" size="small" type="primary">点击上传</el-button>
                            <el-button v-else-if="uploading == 1" size="small" type="primary" :loading="true"
                                style=" display: inline-flex; justify-content: center; align-items: center;">
                                上传中...</el-button>
                            <el-button v-else-if="uploading == 2" size="small" type="primary" :loading="true"
                                style="display: inline-flex;justify-content: center;align-items: center;">
                                努力识别中</el-button>
                        </div>
                        <div slot="tip" class="el-upload__tip" style="margin-top: -6px">
                            上传图片最大6M，支持：JPG/JPEG/GIF/PNG/PDF格式。
                        </div>
                    </el-upload>
                </div>
            </el-form-item>

            <!-- 园区特色标签 -->
            <el-form-item label="企业特色标签" prop="labels">
                <el-input v-model="form.labels[0]" placeholder="请输入特色标签" clearable style="width: 150px" />
                <el-input v-model="form.labels[1]" placeholder="请输入特色标签" clearable
                    style="width: 150px; margin-left: 10px" />
            </el-form-item>

            <!-- 概要介绍（带字数统计） -->
            <el-form-item label="概要介绍 (50字)" prop="summary">
                <el-input v-model="form.summary" placeholder="请输入企业概要介绍" clearable @input="handleSummaryInput" />
                <div style="text-align: right; font-size: 12px; color: #999">
                    还可输入 {{ remainingChars }} 个字
                </div>
            </el-form-item>

            <!-- 园区简介（富文本） -->
            <el-form-item label="企业简介" prop="introduction">
                <vue-editor v-if="dialogVisible" v-model="form.introduction" useCustomImageHandler
                    @image-added="handleImageAdded" />
            </el-form-item>

            <!-- 园区位置标记（Leaflet 地图） -->
            <el-form-item label="企业位置标记" prop="centerPoint">
                <div v-if="dialogVisible" id="map_container" style="height: 300px;"></div>
            </el-form-item>
        </el-form>
        <!-- 底部按钮 -->
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" :loading="submitLoading" :disabled="submitLoading"
                    @click="handleSubmit">提交</el-button>
            </span>
        </template>

    </el-dialog>
</template>

<script>
import { initMap, clearMarkers } from '@/utils/mapUtil/funcs'
import { addOrRegisterCompanyToPark, findLikeFiveByCompanyNameWithBaeInfo, findParkById } from "@/api/projectManage";
import { wgs84togcj02, gcj02towgs84 } from 'coordtransform'
import { mapGetters } from "vuex";
import { getXzqArr, getIdentityList } from "@/api/add";
import { removeEmptyChildren } from "@/js/utils/util";
import { authCompany, getSmsCodeNew, getyyzz, getsfz } from "@/api/certificate";
import { uploadFile, deleteFile } from "@/api/fileApi";
import { VueEditor } from "vue2-editor"

export default {
    name: 'AddCompanyDialog',
    components: {
        VueEditor
    },
    props: {
        dialogTitle: {
            type: String,
            default: '新增企业'
        },
        parkId: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            inputDisabled: false,
            dialogVisible: false,
            companyOptions: [],
            form: {
                parkId: null,
                companyId: null,
                companyName: "",
                socialCreditId: "",
                bossName: "",
                bossPhone: "",
                contactName: "",
                contactPhone: "",
                companyBankId: "",
                areaCode: "",
                address: "",
                bossCardFront: "",
                bossCardBack: "",
                businessLicense: "",
                labels: [],
                summary: "",
                introduction: "",
                centerPoint: []
            },
            initForm: {},
            remainingChars: 50, // 剩余可输入字数
            submitLoading: false,
            map: null,
            marker: null,

            /******************/
            props: {
                label: "areaName",
                children: "children",
                value: "id",
                checkStrictly: true,
                expandTrigger: "hover",
            },
            value1: [], // 第一个级联选择器的值
            value2: [], // 第二个级联选择器的值
            options: [],
            options2: [],

            imgUrl: ["", ""], //身份证人像页的本地图片url
            imgInfo: [undefined, undefined], //身份证人像页的上传返回数据
            baseUrl: window.globalUrl.HOME_API,
            loading: false,
            uploading: 0,
            yyzzIds: [],
            yyzzInfos: [],
            fileList: [],
            imagesIds: [],
            imagesInfos: [],


            rules: {
                companyName: [
                    { required: true, message: '公司名称不能为空', trigger: 'blur' }
                ],
                socialCreditId: [
                    { required: true, message: '社会信用代码不能为空', trigger: 'blur' }
                ],
                bossName: [
                    { required: true, message: '法人姓名不能为空', trigger: 'blur' }
                ],
                bossPhone: [
                    { required: true, message: '联系方式不能为空', trigger: 'blur' }
                ],
                summary: [
                    { max: 50, message: '不超过50字', trigger: 'blur' }
                ]
            }
        };
    },
    created() {
        this.getRegions();
        this.initForm = { ...this.form }
    },
    watch: {
        // 监听弹窗显示状态，初始化地图
        dialogVisible(val) {
            if (val) {
                this.$nextTick(async () => {
                    await this.initData()
                    this.initMap();
                    this.bindMapClick();
                })
            } else {
                this.unbindMapClick();
            }
        }
    },
    computed: {
        ...mapGetters(["userInfo", "identityObj"]),
    },
    methods: {

        // 绑定地图点击事件
        bindMapClick() {
            if (!this.map) return;
            this.map.on('click', this.handleMapClick);
        },

        // 解绑地图点击事件
        unbindMapClick() {
            if (!this.map) return;
            this.map.off('click', this.handleMapClick);
        },

        // 点击地图时的处理
        handleMapClick(e) {
            let wgs84lat = e.latlng.lat
            let wgs84lng = e.latlng.lng
            clearMarkers(this.map.tempLayer)
            this.marker = L.marker([wgs84lat, wgs84lng]).addTo(this.map.tempLayer);
            const [gcjlng, gcjlat] = wgs84togcj02(wgs84lng, wgs84lat)
            this.form.centerPoint = [gcjlat, gcjlng]
        },

        async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            const formData = new FormData()
            formData.append("file", file)
            formData.append("catalog", "park-management");
            try {
                let res = await uploadFile(formData);
                // let fileName = res.data.sourceFileName;
                let url = window.globalUrl.HOME_API + "/admin/file/get?ossFilePath=" + res.data.url;
                Editor.insertEmbed(cursorLocation, "image", url)
                resetUploader()
            } catch (err) {
                console.error(err)
            }
        },

        async uploadFile(file, type) {
            let param = new FormData();
            param.append("catalog", "register");
            param.append("file", file.raw);
            // console.time('myCode')
            let res = await uploadFile(param);

            if (res.code == 0) {
                this.uploading = 2;
            } else {
                this.$message.error("上传失败");
                const indexOfFile = filelist.indexOf(file);
                filelist.splice(indexOfFile, 1);
            }

            // console.timeEnd('myCode'); // 结束计时并输出执行时间
            console.log("yyzz", res);
            console.time("myCode");
            let res1 = await getyyzz({
                identity: res.data.thumbnailUrl ? res.data.thumbnailUrl : res.data.url,
            });
            console.timeEnd("myCode"); // 结束计时并输出执行时间
            console.log("res-yyzz", res1);
            // 判断是否已经填过信息 填过则不赋值
            // this.form.companyName = this.form.companyName
            //     ? this.form.companyName
            //     : res1.data.returnObj.detail.name;
            this.form.socialCreditId = this.form.socialCreditId
                ? this.form.socialCreditId
                : res1.data.returnObj.detail.union_id;
            if (res.code == 0) {
                if (type == "yyzz") {
                    this.yyzzIds.push(file.uid);
                    this.yyzzInfos.push(res.data.url);
                    setTimeout(() => {
                        this.form.businessLicense = this.yyzzInfos
                            ? this.yyzzInfos.join(",")
                            : "";
                        // this.$refs.form.validateField("businessLicense");
                    }, 100);
                } else if (type == "images") {
                    this.imagesIds.push(file.uid);
                    this.imagesInfos.push(res.data.url);
                }
            }
            this.uploading = 0;
        },

        removeYyzz(file) {
            let index = this.yyzzIds.indexOf(file.uid);
            // this.deleteFile(this.yyzzInfos[index]);
            this.yyzzIds.splice(index, 1);
            this.yyzzInfos.splice(index, 1);
            this.uploading = 0;
        },

        async uploadYyzz(file, filelist) {
            const isJPG =
                file.raw.type === "image/jpeg" || file.raw.type === "image/png";
            const isPDF = file.raw.type === "application/pdf";
            // const isLt6M = file.raw.size / 1024 / 1024 < 6;
            if (!isJPG && !isPDF) {
                this.$message.error("只能上传 JPG/JPEG/PNG/GIF/PDF 格式的图片或文件");
                const indexOfFile = filelist.indexOf(file);
                filelist.splice(indexOfFile, 1);
                return;
            }
            this.uploading = 1;
            // if (!isLt6M) {
            //   this.$message.error("上传图片或文件大小不能超过 6MB");
            //   const indexOfFile = filelist.indexOf(file);
            //   filelist.splice(indexOfFile, 1);
            //   return
            // }

            let res = await this.uploadFile(file, "yyzz");

            console.log("file", file, filelist);

            // this.yyzz
            // const base64 = await this.getBase64(file.raw);
            // console.log("64", base64);
            // const res1 = await this.sendRequest(base64);
            // console.log(res1);
        },

        async uploadSfz(file, type) {
            let imgIndex = type * 1; //在数组中的索引
            let param = new FormData();
            param.append("catalog", "sfz");
            param.append("file", file);
            // console.time('myCode')
            let res = await uploadFile(param);
            // console.timeEnd("myCode");
            console.log("res", res);

            if (res.code == 0) {
                this.$set(this.imgUrl, imgIndex, res.data.url);
                this.imgInfo[imgIndex] = res.data.url;
                console.log("imgUrl", this.imgUrl);
            } else {
                this.$message.error('上传失败，请重新上传')
            }

            this.loading = false;
        },

        async deleteFile(url) {
            let res = await deleteFile({ ossFilePath: url });
            if (res.code == 0 && res.data == true) {
                console.log("删除成功");
            }
        },

        checkFormat(file) {
            // console.log("file", file);
            // console.log("file.type", file.type);
            const isJPG = file.type === "image/jpeg" || file.type === "image/png";
            const isLt6M = file.size / 1024 / 1024 < 6;
            if (!isJPG) {
                this.$message.error("只能上传 JPG/JPEG/PNG 格式的图片或文件");
            }
            if (!isLt6M) {
                this.$message.error("上传图片大小不能超过 6MB");
            }
            return isJPG && isLt6M;
        },

        //上传身份证
        async handleChange(file, type) {
            let imgIndex = type * 1; //在数组中的索引
            if (this.checkFormat(file.raw)) {
                if (type == 0) {
                    this.loading = true;
                }

                //符合格式要求
                if (this.imgInfo[imgIndex]) {
                    //更换新的照片时需要删除旧照片
                    this.deleteFile(this.imgInfo[imgIndex]);
                    this.imgInfo[imgIndex] = undefined;
                }
                let res = await this.uploadSfz(file.raw, type);
                // if(res.code==0){

                // }else{
                //   this.$message.error('上传失败！')
                // }
                console.log("res", res);
            }
        },

        async getRegions() {
            // 获取行政区树
            let res = await getXzqArr({
                level: 3,
            });
            if (res.code == 0) {
                this.options = removeEmptyChildren(res.data, "children");
            }
        },

        async cityChange(val) {
            // console.log("val", val);
            if (val) {
                let params = { parentCode: val[val.length - 1] };
                let res = await getXzqArr(params);
                if (res.code == 0) {
                    this.value2 = null;
                    this.form.areaCode = val[val.length - 1];
                    // console.log("this.form.areaCode", this.form.areaCode);
                    if (res.data.length > 0) {
                        this.options2 = removeEmptyChildren(res.data, "children");
                        // this.areaHasChild = true;
                    } else {
                        this.options2 = [];
                        // this.areaHasChild = false;
                    }
                }
            }
        },
        roadChange(val) {

            let node = this.$refs.address2.getCheckedNodes()[0];

            // let [lon, lat] = node.data.centerPoint.split(",")
            // this.form.centerPoint = [Number(lat), Number(lon)]
            // this.initMap()
            if (node.children.length == 0) {
                // this.areaHasChild = false;
                this.form.areaCode = val[val.length - 1];
            } else {
                // this.areaHasChild = true;
                this.form.areaCode = val[val.length - 1];
            }

        },

        handleCompanyChange(companyName) {
            console.log('选择的公司', companyName)
            //清空营业执照
            this.$refs.businessLicenseRef.clearFiles();
            // 当用户选择选项时，更新companyId
            const selected = this.companyOptions.find(c => c.companyName === companyName);
            if (selected) {
                this.inputDisabled = true
                this.form.companyId = selected.companyId;
                this.form.companyName = selected.companyName;
                this.form.socialCreditId = selected.socialCreditId;
                this.form.bossName = selected.bossName;
                this.form.bossPhone = selected.bossPhone;
                this.form.contactName = selected.contactName;
                this.form.contactPhone = selected.contactPhone;
                this.form.companyBankId = selected.companyBankId;
                this.form.address = selected.address;
                this.form.areaCode = selected.areaCode;
                this.form.bossCardFront = selected.bossCardFront;
                this.form.bossCardBack = selected.bossCardBack;
                this.imgUrl = [selected.bossCardFront, selected.bossCardBack]
                this.form.businessLicense = selected.businessLicense;

                console.log(this.form, selected)
            } else {
                this.inputDisabled = false
                this.form.companyId = null
                this.form.companyName = companyName;
                this.form.socialCreditId = "";
                this.form.bossName = "";
                this.form.bossPhone = "";
                this.form.contactName = "";
                this.form.contactPhone = "";
                this.form.companyBankId = "";

                this.form.areaCode = "";
                this.value1 = []
                this.value2 = []

                this.form.bossCardFront = "";
                this.form.bossCardBack = "";
                this.imgUrl = ["", ""],

                this.form.businessLicense = "";
            }
        },

        async handleSearchCompanyList(companyName) {
            if (companyName !== '') {
                let res = await findLikeFiveByCompanyNameWithBaeInfo({ companyName: companyName })
                if (res.success) {
                    this.companyOptions = res.data
                }
            } else {
                this.options = [];
            }
        },

        // 初始化地图
        initMap() {
            this.map = initMap("map_container")
            this.setMarker(this.form.centerPoint[0], this.form.centerPoint[1])
        },

        async initData() {
            let res = await findParkById({ id: this.parkId });
            if (res.success) {
                //返回的经纬度
                let centerPoint = res.data.centerPoint
                console.log(res.data.centerPoint, 'res.data.centerPoint')
                this.form.centerPoint = [centerPoint[1], centerPoint[0]]
            }
            return
        },

        // 设置标记并缩放地图(纬经度)
        setMarker(lat, lng) {
            clearMarkers(this.map.tempLayer)
            const [wgs84lng, wgs84lat] = gcj02towgs84(lng, lat)
            this.marker = L.marker([wgs84lat, wgs84lng]).addTo(this.map.tempLayer);
            this.map.setView([wgs84lat, wgs84lng], 13);
            this.form.centerPoint = [lat, lng]
        },

        // 概要介绍输入监听，计算剩余字数
        handleSummaryInput() {
            const maxLength = 50;
            const currentLength = this.form.summary.length;
            this.remainingChars = maxLength - currentLength;
        },


        // 取消按钮
        handleCancel() {
            this.handleClose()
        },

        // 提交按钮
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    // 开始提交，锁定按钮
                    this.submitLoading = true;
                    try {
                        let dto = {
                            ...this.form,
                            parkId: this.parkId,
                            bossCardFront: this.imgUrl[0],
                            bossCardBack: this.imgUrl[1],
                        }
                        console.log(dto, 'dto-------')
                        let res = await addOrRegisterCompanyToPark(dto);
                        if (res.success) {
                            this.$message.success("操作成功");
                            this.handleClose()
                            this.$emit('load')
                        } else {
                            this.$message.error(res.msg);
                        }
                    } catch (error) {
                        console.error("提交失败:", error);
                    } finally {
                        // 无论成功失败，都解除锁定
                        this.submitLoading = false;
                    }
                }
            });
        },

        // 关闭弹窗回调
        handleClose() {
            this.resetForm();
            this.dialogVisible = false;
        },

        // 重置表单
        resetForm() {
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate()
            })
            this.form = { ...this.initForm }
            this.form.labels = []
            this.inputDisabled = false
            this.value1 = []
            this.value2 = []
            this.imgUrl = ["", ""]
            this.$refs.businessLicenseRef.clearFiles();
            this.loading = false
            this.remainingChars = 50;
            if (this.marker) {
                this.map.tempLayer.removeLayer(this.marker);
                this.marker = null;
            }
        }
    },
};
</script>

<style lang="less" scoped>
/* 调整富文本编辑器样式，适配弹窗 */
.ql-editor {
    min-height: 100px;
}

/* 地图容器初始化隐藏滚动条（可选） */
#parkMap {
    overflow: hidden;
}

.upload-box {
    /deep/.el-upload {
        width: 148px !important;
        height: 126px !important;

        img {
            width: 100%;
            height: 126px
        }
    }

    // .el-upload-list--picture-card .el-upload-list__item {
    //   width: 301px;
    //   height: 261px;
    // }
}

/deep/.el-form-item__content {
    text-align: left;
}

/deep/.el-loading-spinner {
    // text-align: left;
    width: 39% !important;
}

/deep/.el-loading-text {
    // text-align: left;
    margin-top: -29px;
}
</style>